import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ConfirmDialogComponent } from 'src/app/shared/services/confirm-dialog.service';

@NgModule({
    imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
    declarations: [ConfirmDialogComponent],
    providers: [],
    exports: [ConfirmDialogComponent]
})
export class ConfirmDialogModule {}
